import type { CustomersPageResult } from "./types";
import { typedQuery } from "../../../typed-query";

const cardProjection = `{
    "company": caseStudy->company-> {
      name,
      "logoUrl": coalesce(logo.asset->url, logoWhite.asset->url),
    },
    "title": caseStudy->hero.headline,
    "slug": coalesce(caseStudy->slug.current, caseStudy->slug),
    summary,
    "imageUrl": media.asset->url,
    mediaType,
    "chart": select(mediaType == "chart" => chart {
      type,
      description,
      ...select(type == "bar" => ({
        "data": dataBar {
          unit,
          xaxis[]{ label, value, highlight },
          yaxis
        }
      })),
      ...select(type == "line" => ({
        "data": dataLine {
          unit,
          xaxis[]{ name, "label": axisLabel, value },
          yaxis[]{ value }
        }
      })),
      ...select(type == "stats" => ({
        "data": dataStats[]{ label, value, graphValue }
      }))
    }),
    "stats": caseStudy->stats[] { label, value },
    "representative": caseStudy->companyRepresentatives[0] { name, jobTitle },
    "industries": caseStudy->company->industries,
    "topics": caseStudy->topics,
    "site": caseStudy->site,
  }`;

export const customersPageQuery = typedQuery<CustomersPageResult>(`
*[_type == "intercomCustomersPage" && _id == "intercomCustomersPageSingleton"][0] {
  featuredCaseStudyCards[]-> ${cardProjection},
  caseStudyCards[]-> ${cardProjection},
  logos[]-> {
    _id,
    name,
    "logoUrl": coalesce(logo.asset->url, logoWhite.asset->url),
    "industries": industries,
  },
  testimonials[]-> {
    "company": customer-> {
      name,
      "logoUrl": coalesce(logo.asset->url, logoWhite.asset->url),
    },
    "quote": pt::text(quote),
    name,
    jobTitle,
    "portraitUrl": portrait.asset->url,
    "industries": customer->industries,
    "topics": topics,
  },
  "hiddenIndustries": hiddenFilters[@->_type == "industry"]->slug.current,
  "hiddenTopics": hiddenFilters[@->_type == "topic"]->slug.current,
}
`);
